// A single wallet holding half an outcome is the whale signal this recap exists to
// surface, so it always warns in the comparison card and the table. In methodology v4
// largest-holder share also scores, but it shares one budget with top-5 and only the
// harsher deducts: when top-5 takes the penalty, `flagged` stays false here and this
// warning is what still marks the whale. The glyphs differ (outline = lowered the score,
// solid = lopsided holder), so the meaning is not colour-only.
export const CONCENTRATION_WARNING_PPB = 500_000_000;

export function isLopsidedShare(sharePpb: number | null): boolean {
  return sharePpb !== null && sharePpb >= CONCENTRATION_WARNING_PPB;
}
